import React from 'react'

const Deal = () => {
  return (
    <section id="deal">
    <div className="wrapper">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center border border-white deal-of-the-day py-5">
              <div className="text-content py-5">
                <h2>DEALS OF THE DAY</h2>
                <h4>UPTO 60% OFF</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                  et dolore magna aliqua.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Deal
